import React from 'react';
import { useContacts } from '../../context/ContactsContext';
import { useMessages } from '../../context/MessagesContext';
import { Button } from '../common/Button';

export function ChatHeader({ contact }) {
  const { updateContact, archiveContact, deleteContact } = useContacts();
  const { typingUsers } = useMessages();

  const handleArchive = () => {
    archiveContact(contact.id, !contact.isArchived);
  };

  const handleBlock = () => {
    updateContact(contact.id, { isBlocked: !contact.isBlocked });
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this contact?')) {
      deleteContact(contact.id);
    }
  };

  return (
    <div className="bg-white p-4 border-b border-gray-300 flex justify-between items-center">
      <div>
        <h3 className="font-bold text-lg">
          {contact.alias || contact.contactUuid}
        </h3>
        <p className="text-xs text-gray-500">
          Key v{contact.keyVersion}
          {contact.isArchived && (
            <span className="ml-2 text-gray-400">(Archived)</span>
          )}
          {typingUsers[contact.contactUuid] && (
            <span className="ml-2 text-green-600 italic">typing...</span>
          )}
        </p>
      </div>
      <div className="flex space-x-2">
        <Button
          onClick={handleBlock}
          variant={contact.isBlocked ? 'success' : 'danger'}
          size="sm"
        >
          {contact.isBlocked ? 'Unblock' : 'Block'}
        </Button>
        <Button
          onClick={handleArchive}
          variant="secondary"
          size="sm"
        >
          {contact.isArchived ? '📤 Unarchive' : '📁 Archive'}
        </Button>
        <Button
          onClick={handleDelete}
          variant="danger"
          size="sm"
        >
          Delete
        </Button>
      </div>
    </div>
  );
}